type DateLike = number | string | Date;

export default function utc0(value: DateLike) {
  const date = new Date(value);
  return date.getTime() + date.getTimezoneOffset() * 60 * 1000;
}

export function utc0Date(value: DateLike) {
  return new Date(utc0(value));
}

export function serverOtc0Date(value: DateLike) {
  const date = new Date(value);
  return new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
}
